import {db} from "@/main";
import {
    FirestoreDataConverter,
    collection,
    getDocs,
    setDoc,
    doc,
    deleteDoc,
    getDoc,
    writeBatch
} from "firebase/firestore";

const templateDataConverter: FirestoreDataConverter<TemplateData> = {
    toFirestore(data: TemplateData) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return { ...data, } as TemplateData;
    }
};

const wishDataDateConverter: FirestoreDataConverter<WishDataDate> = {
    toFirestore(data: WishDataDate) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            ...data,
            date: data.date.toDate(),
        } as WishDataDate;
    }
};

export function GetTemplateData(templateId: string): Promise<TemplateData> {
    return new Promise<TemplateData>(async (resolve, reject) => {
        try {
            const templateDataRef =  doc(db, "templates", templateId).withConverter(templateDataConverter);

            const templateSnapshot = await getDoc(templateDataRef);

            if(templateSnapshot.exists()) {
                const returnTemplateData = {...templateSnapshot.data(), dates: []} as TemplateData;
                const wishDataDatesColRef = collection(templateSnapshot.ref, "dates").withConverter(wishDataDateConverter);
                
                getDocs(wishDataDatesColRef)
                    .then((wishDataDateSnapshot) => {
                        wishDataDateSnapshot.forEach((doc) => {
                            returnTemplateData.dates.push(doc.data() as WishDataDate);
                        });
                    })
                    .catch((error) => {
                        reject(`Error fetching TemplateDataDates: ${error}`);
                    })
                    .finally(() => {
                    resolve(returnTemplateData);
                    });
            }
            else{
                reject("No matching template found!");
            }
        } catch (error) {
            reject(error);
        }
    })}

export function InsertTemplateData(templateData: TemplateData): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        setDoc(doc(db, "templates", templateData.id), {
            id: templateData.id,
            name: templateData.name,
            userId: templateData.userId.toString()
        }, { merge: true })
            .then(() => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            });

    })}

export function InsertTemplateDataDates(templateDataId: string, templateDataDates: WishDataDate[]): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
        try {
            let templateDataDoc = doc(db, "templates", templateDataId);
            const dateColRef = collection(templateDataDoc, "dates");
            const dateSnapshot = await getDocs(dateColRef);
            
            let batch = writeBatch(db);
            let batchCount = 0;
            
            for (const document of dateSnapshot.docs) {
                batch.delete(doc(db, "templates", templateDataId, "dates", document.id));
                batchCount++;
                
                if (batchCount === 500) {
                    await batch.commit();
                    batch = writeBatch(db);
                    batchCount = 0;
                }
            }
            
            if (batchCount > 0) {
                await batch.commit();
            }
            
            batch = writeBatch(db);
            batchCount = 0;
            
            for (const date of templateDataDates) {
                batch.set(doc(db, "templates", templateDataId, "dates", date.id), {
                    id: date.id,
                    date: date.date,
                    shift: date.shift,
                });
                batchCount++;
                
                if (batchCount === 500) {
                    await batch.commit();
                    batch = writeBatch(db); 
                    batchCount = 0;
                }
            }
            
            if (batchCount > 0) {
                await batch.commit();
            }
        } catch (error) {
            reject(error);
        }
        finally{
            resolve();
        }
    });
}

export function DeleteTemplateData(templateDataId: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        deleteDoc(doc(db, "templates", templateDataId))
            .then(() => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            });
    })}